<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Close from 'assets/images/close.svg?component'

const isOpen = ref(false)
const signin = ref(false)

function onShow() {
  isOpen.value = true
}

function onHide() {
  isOpen.value = false
}

function onSignin() {
  isOpen.value = true
  signin.value = true
}

function onSignup() {
  isOpen.value = true
  signin.value = false
}

onMounted(() => {
  if (typeof window === 'undefined') return
  window.addEventListener('show-auth-prompt', onShow)
  window.addEventListener('hide-auth-prompt', onHide)
  window.addEventListener('show-auth-prompt-signin', onSignin)
  window.addEventListener('show-auth-prompt-signup', onSignup)
})

onUnmounted(() => {
  if (typeof window === 'undefined') return
  window.removeEventListener('show-auth-prompt', onShow)
  window.removeEventListener('hide-auth-prompt', onHide)
  window.removeEventListener('show-auth-prompt-signin', onSignin)
  window.removeEventListener('show-auth-prompt-signup', onSignup)
})

function onClose() {
  isOpen.value = false
}

watch(isOpen, (open, previous) => {
  if (!open && previous) {
    window.dispatchEvent(new CustomEvent('close-auth-prompt'))
  }
})
</script>

<template>
  <UModal
    v-model="isOpen"
    :ui="{ width: 'w-[100dvh] md:w-[90dvh] max-w-[100dvh] md:max-w-[90dvh] h-[90dvh] md:h-[90dvh]' }"
  >
    <div class="p-4 overflow-y-auto">
      <div class="flex w-full justify-end">
        <PButton
          id="auth-popup-close"
          :click="onClose"
        >
          <Close class="w-5 h-5 stroke-black" />
        </PButton>
      </div>
      <AuthenticationSignin
        v-if="signin"
        :popup="true"
      />
      <AuthenticationSignup
        v-else
        :popup="true"
      />
    </div>
  </UModal>
</template>
